//hooks
import {useState} from 'react'

//component
import Login from "./Login";
import Signup from "./Signup";
import ForgetPassword from './ForgetPassword';
import ResetPassword from './ResetPassword';

//mui
import Button from '@mui/material/Button';

//translate
import { useTranslation } from 'react-i18next';

//type
interface AuthDialogProps {
    setOpenOtp: (open:boolean)=>void
}

const AuthDialog = ({setOpenOtp}: AuthDialogProps) => {
    const {t} = useTranslation()
    const [openLogin, setOpenLogin] = useState<boolean>(false);
    const [openSignup, setOpenSignup] = useState<boolean>(false);
    const [openForgetPassword, setOpenForgetPassword] = useState<boolean>(false);
    const [openResetPassword, setOpenResetPassword] = useState<boolean>(false);

    // start functions

    const handleOpenLogin = ()=> {
        setOpenLogin(true)
    }

    // end functions

    return (
            <div>
            <Button className='!bg-customerColor' color="inherit" onClick={handleOpenLogin}>
                {t("login")}
            </Button>

            <Login
                openLogin={openLogin}
                setOpenLogin={setOpenLogin}
                setOpenSignup={setOpenSignup}
                setOpenForgetPassword={setOpenForgetPassword}
            />

            <Signup
                openSignup={openSignup}
                setOpenSignup={setOpenSignup}
                setOpenOtp = {setOpenOtp}
            />

            <ForgetPassword
                openForgetPassword={openForgetPassword}
                setOpenForgetPassword={setOpenForgetPassword}
                setOpenResetPassword={setOpenResetPassword}
            />
            <ResetPassword
                openResetPassword={openResetPassword}
                setOpenResetPassword={setOpenResetPassword}
            />
            
        </div>
    )
}

export default AuthDialog